import { Services } from "appworks/services/services";
import { AutoCountTextControl } from "appworks/ui/controls/standard/text/auto-count-text-control";

export class GamevyAutoSpinCountControl extends AutoCountTextControl {
    protected updateCount = () => {
        const value = Services.autoplay.getAutoplays();
        const isInfinity = isNaN(value) || value === Number.POSITIVE_INFINITY;
        const label: string = isInfinity ? "∞" : value.toString();
        this.text.setText(label);
    }
}
